import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { useState } from "react";
import { auth } from "../../../../firebase/firebase";
import { useAuth } from "../../../../context/AuthContext";

function CheckmarkIcon() {
  return (
    <svg
      width="100px"
      height="100px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      color="#34c759"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  );
}

const Step5 = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const authContext = useAuth();
  useEffect(() => {
    const updateAuth = async () => {
      await authContext?.refreshAuth();
      await authContext?.getMyInvites();
      await auth.currentUser?.reload();
      navigate("../../dashboard");
    };
    updateAuth();
  }, []);

  return (
    <section>
      <div className="container">
        <div className="grid grid-cols-1 gap-3 p-5 md:grid-cols-2 gap-x-5 gap-y-5">
          {/* Left Container */}
          <div className="flex flex-col items-start justify-start">
            <h1 className="herotitle">Skarvo</h1>
            <p className="text-xl font-normal">Your Skarvo Business account was successfully created.</p>
          </div>

          {/* Right Container */}
          <div className="flex flex-col gap-10">
            <div className="flex flex-col items-start formcard">
              <div className="flex flex-row items-start formheader">
                <div className="text-xl font-bold text-center mt-[15px] mb-[30px]">Sign Up</div>
              </div>
              <div className="flex justify-center w-full px-[30px] mb-[30px]">
                <div className=" bg-skseparatorgray w-full rounded-full h-[5px]">
                  <div className=" bg-skgreen h-[5px] rounded-full" style={{ width: "100%" }}></div>
                </div>
              </div>
              <div className="mb-5 px-[30px] flex flex-col space-y-[10px] w-full">
                <div className="flex flex-col items-start items-center justify-center formbodytext">
                  <CheckmarkIcon />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Step5;
